import { render, staticRenderFns } from "./OnboardingVerify.vue?vue&type=template&id=359a5efd&scoped=true&"
import script from "./OnboardingVerify.vue?vue&type=script&lang=js&"
export * from "./OnboardingVerify.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingVerify.vue?vue&type=style&index=0&id=359a5efd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359a5efd",
  null
  
)

export default component.exports